var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jsmind_layout"},[(_vm.mindV)?_c('div',{staticClass:"noMind"},[_c('img',{attrs:{"src":require("../../assets/nominddata.png"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{ref:"container",attrs:{"id":"jsmind_container"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6388d12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tools/jsmind.vue
// module id = null
// module chunks = 